import React from "react";
import InnerHTML from "dangerously-set-html-content";
import PropTypes from "prop-types";
import {
    truncateHTMLString,
    translateStoreIconClassToGlyph,
} from "@qgiv/core-js";
import { Icon } from "@qgiv/core-react";
import { CardImage } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";

const StoreItem = ({
    displayDesc = false,
    indexOfItemAlreadyInCart = -1,
    product,
    productPrice = "",
    setProductModalOpen,
    updateCurrentStoreCartItemIndex,
}) => {
    const dispatch = useDispatch();

    const { id, imgSrc, title, icon, description } = product;

    const translatedIcon = translateStoreIconClassToGlyph(icon);
    const handleOpenDetailsModal = (e) => {
        e.preventDefault();

        dispatch(
            setProductModalOpen({
                productModalOpen: true,
                currentProductId: id,
                modalAccessedFromStoreList: true,
            }),
        );
        if (indexOfItemAlreadyInCart && indexOfItemAlreadyInCart !== -1) {
            dispatch(updateCurrentStoreCartItemIndex(indexOfItemAlreadyInCart));
        }
    };

    return (
        // eslint-disable-next-line react/jsx-no-comment-textnodes
        <div className="store-items__item -padding-bottom--30">
            <div
                className={`store-items__item--img-container ${
                    !imgSrc && "-callout -margin-bottom--10"
                }`}
                role="button"
                tabIndex="0"
                onKeyDown={handleOpenDetailsModal}
                onClick={handleOpenDetailsModal}
            >
                {imgSrc ? (
                    <CardImage url={imgSrc} altText={title} display="square" />
                ) : (
                    <div className="store-items__item--icon">
                        <Icon
                            glyph={translatedIcon.glyph}
                            type={translatedIcon.type}
                        />
                    </div>
                )}
            </div>
            <div className="-padding-top--10">
                <button
                    type="button"
                    id={`product-${id}`}
                    className="store-items__item--title"
                    onClick={handleOpenDetailsModal}
                    aria-label={`${title}: View Product Details`}
                >
                    <strong>{title}</strong>
                </button>
            </div>
            <div className="store-items__item--price">
                <p>{productPrice}</p>
            </div>
            {displayDesc && (
                <div className="store-items__item--desc -text--center">
                    <small>
                        <InnerHTML html={truncateHTMLString(description, 50)} />
                    </small>
                </div>
            )}
        </div>
    );
};

StoreItem.propTypes = {
    displayDesc: PropTypes.bool,
    indexOfItemAlreadyInCart: PropTypes.number,
    product: PropTypes.shape({
        id: PropTypes.number,
        imgSrc: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        icon: PropTypes.string,
    }).isRequired,
    productPrice: PropTypes.string,
    setProductModalOpen: PropTypes.func.isRequired,
    updateCurrentStoreCartItemIndex: PropTypes.func.isRequired,
};

export default StoreItem;
